// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"9289dc57","488":"885f458f"}[chunkId] + ".chunk.js";
};